import { motion } from "framer-motion";

// Notable guests/networks featured across the produced work.
const brands = [
  "Masoom Minawala",
  "Kushal Lodha",
  "Rahul Jain",
  "Sanjay Kathuria",
  "Gunjan Shouts",
  "Prakhar Gupta",
  "Sonia Shenoy",
  "Groww",
  "Zero1 Network",
];

export default function TrustedBy() {
  return (
    <section
      data-testid="trusted-by-section"
      aria-label="Trusted by"
      className="relative border-y border-[#141414] bg-[#050505]/60"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-16 lg:px-32 py-8 md:py-10 flex flex-col md:flex-row items-center gap-6 md:gap-10">
        <div
          data-testid="trusted-by-label"
          className="flex items-center gap-3 shrink-0"
        >
          <span className="w-8 h-px bg-[#F4C75E]" />
          <span className="text-[10px] md:text-xs uppercase tracking-[0.35em] text-[#F4C75E] font-bold whitespace-nowrap">
            Trusted By
          </span>
        </div>

        <div className="relative flex-1 overflow-hidden w-full [mask-image:linear-gradient(to_right,transparent,black_10%,black_90%,transparent)]">
          <motion.ul
            initial={{ x: 0 }}
            animate={{ x: "-50%" }}
            transition={{ duration: 40, ease: "linear", repeat: Infinity }}
            className="flex items-center gap-10 md:gap-14 whitespace-nowrap w-max"
          >
            {[...brands, ...brands].map((b, i) => (
              <li
                key={i}
                data-testid={`trusted-by-brand-${i}`}
                className="font-display text-sm md:text-base uppercase tracking-[0.22em] text-[#A3A3A3] hover:text-[#F5F5F5] transition-colors duration-300 flex items-center gap-10 md:gap-14"
              >
                <span>{b}</span>
                <span aria-hidden="true" className="w-1 h-1 rounded-full bg-[#F4C75E]/50" />
              </li>
            ))}
          </motion.ul>
        </div>
      </div>
    </section>
  );
}
